import {applyMiddleware, createStore} from 'redux';
import {createLogger} from 'redux-logger';
import {thunk} from 'redux-thunk';

export default (reducer, state, options = {}) => {
  const {logger = true} = options;
  const middlewares = [thunk];
  if (logger) {
    middlewares.push(createLogger());
  }
  return createStore(reducer, state, applyMiddleware(...middlewares));
};
